import React, { FC, useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';

import { className } from 'core/lib/className';
import { fromEPSG4326 } from 'ol/proj/epsg3857';
import { getAssetType } from 'core/misc/assetTypes';
import MapMarker from 'core/react/general/location/MapMarker';
import { getOwMap, Map } from 'core/react/general/location/Map';
import { assetTypesSelector } from 'core/redux/selectors/categories';
import { devicesListSelector, devicesStatusesSelector } from 'core/redux/selectors/devices';

import 'core/react/custom/map/deviceMapMarker.scss';

interface IMarkerProps {
  mapName: string;
  map: Map;
  uri: string;
  heading?: number;
  coordinates: number[] | null;
}

export const Marker: FC<IMarkerProps> = (props) => {
  const { mapName, map, uri, heading, coordinates } = props;

  const devicesStatuses = useSelector(devicesStatusesSelector);
  const { map: assetTypes } = useSelector(assetTypesSelector);
  const devices = useSelector(devicesListSelector);

  const markerRef = useRef<MapMarker | null>(null);

  const device = devices?.find((d) => d.uri === uri);
  const deviceStatus = uri && devicesStatuses ? devicesStatuses[uri]?.status?.toLowerCase() : null;

  const isHeading = heading || heading === 0;
  const bodyStyle = isHeading ? { transform: 'rotate(' + heading + 'deg)' } : null;
  const assetType = device ? getAssetType(device.categoryIds, assetTypes) : null;

  useEffect(() => {
    if (coordinates) {
      const center = fromEPSG4326(coordinates);
      getOwMap(mapName).focus(center, 16);
    }
  }, [coordinates]);

  return device && coordinates ? (
    <MapMarker
      className={className(deviceStatus, assetType && assetType.getType(), { pointer: isHeading })}
      ref={markerRef}
      map={map}
      coordinates={coordinates}
      id={device.uri}
      title={device.denomination()}
      label={device.denomination()}
      bodyStyle={bodyStyle}
      properties={{ domain: 'device' }}
    />
  ) : null;
};
